export default "__VITE_ASSET__CyGtkNAG__"